import { type ReactNode, useState } from 'react';

export function Card({ title, collapsible = false, children }: { title: string; collapsible?: boolean; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  if (!collapsible)
    return (
      <section className="card">
        <h2>{title}</h2>
        {children}
      </section>
    );
  return (
    <section className="card" aria-label={title}>
      <div className="section-head">
        <h2>{title}</h2>
        <button type="button" className="btn btn-small btn-ghost" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
          {open ? 'Einklappen' : 'Anzeigen'}
        </button>
      </div>
      {open && children}
    </section>
  );
}
